// components/TimezoneInitializer.tsx
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCurrentBusinessConfig } from '../../firebase/firebase-delegate';
import { setDefaultTimezone } from '../../utils/dayjs-config';

const TimezoneInitializer = () => {
  const businessConfigQuery = useQuery({
    queryKey: ['businessConfig'],
    queryFn: () => getCurrentBusinessConfig(),
  });

  useEffect(() => {
    if (businessConfigQuery.data?.businessInfo?.timezone) {
      setDefaultTimezone(businessConfigQuery.data.businessInfo.timezone);
    }
  }, [businessConfigQuery.data]);

  return null; // This component does not render anything visible
};

export default TimezoneInitializer;
